import React, { Component } from 'react';
import * as GlobalActions from '../../reducers/actions';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { S3HOST } from '../../ApiConstants';
import FormStyles from './FormStyles';
import LandingImages from '../LandingPageNew/LandingImages';
import view, { formView, validation, borders, propertyType } from '../../Enums';
import Header from '../../common/Header/Header';
import { debounce } from '../../utils/functionUtils';
import FormOne from './FormOne';
import StaticContent from './StaticContent';
import FormSeller2 from './FormSeller2';
import FormHotel2 from './FormHotel2';
import FormHome2 from './FormHome2';
import Form3New from './Form3New';
import { Event } from '../LandingPageNew/Tracking/Track';
import { getConcatanatedUTMData } from '../../utils/campaignUtils';
import countryNamesByISO from '../../utils/regionCodeMappings';
import { validateUserPhoneNumber } from '../../utils/tempInputUtils';
import Network from '../../services/Network';
import { TRANSLATION_AND_IMAGES } from '../../utils/endpoints';
import * as TranslationActions from '../../reducers/TranslationsReducer/actions';

class FormScreenNew extends Component {
  constructor(props) {
    super(props);

    this.getImage = this.getImage.bind(this);
    this.getStyle = this.getStyle.bind(this);
    this.getUniversalContent = this.getUniversalContent.bind(this);
    this.getContent = this.getContent.bind(this);
    this.validateCurrentForm = this.validateCurrentForm.bind(this);
    this.validate = this.validate.bind(this);
    this.backToStepOne = this.backToStepOne.bind(this);
    this.switchFormTwoView = this.switchFormTwoView.bind(this);
    this.backForm = this.backForm.bind(this);
    this.openStep2Form = this.openStep2Form.bind(this);
  }

  state = {
    viewMode: null,
    selectedLocation: null,
    screenheight: 800,
    formViewMode: formView.STEP_TWO_HOME,
    stepOneBorderNameValidated: true,
    stepOneBorderPhoneNumber: true,
    stepOneBorderLocation: true,
    homeBorderStructureType: true,
    homeBorderAddress: true,
    hotelBorderPropertyValidated: true,
    hotelBorderEmail: true,
    sellerBorderHotelValidated: true,
    sellerBorderAddress: true,
    sellerBorderNumberOfRooms: true,
    location: ''
  };

  componentDidMount() {
    window.scrollTo(0, 0);

    if (this.props.globalData.selected_location) {
      this.setState({
        selectedLocation: this.props.globalData.selected_location
      });
    }

    if (this.props.globalData && !this.props.globalData.form_translations) {
      const country= this.props.globalData.locale;
      const  locale= this.props.globalData.lang;
      Network.GET(TRANSLATION_AND_IMAGES, {
        country: country,
        locale: locale
      }, null, res => {
        this.props.globalActions.updateGlobalData(res);
        this.props.translationActions.updateTranslationsData(res);
      }, console.log);
    }

    if (this.props.globalData) {
      if (
        this.props.globalData.location &&
        this.props.globalData.formData.mobile_number &&
        this.props.globalData.formData.full_name
      ) {
        if (this.props.globalData.are_you_a_seller) {
          this.setState({ formViewMode: formView.STEP_TWO_SELLER });
        } else {
          if (this.props.globalData.type_of_property === propertyType.HOME) {
            this.setState({ formViewMode: formView.STEP_TWO_HOME });
          } else {
            if(this.props.globalData.formData.hotel_address && this.props.globalData.formData.email_address && this.props.globalData.formData.hotel_name){
              this.props.globalActions.emptyFormData();
              this.setState({ formViewMode: formView.STEP_THREE });
            }
           else this.setState({ formViewMode: formView.STEP_TWO_HOTEL });
          }
        }
      } else {
        this.setState({ formViewMode: formView.STEP_ONE });
      }
    } else {
      console.log('global data not found');
    }

    this.formResizeHandler();
    window.addEventListener('resize', debounce(this.formResizeHandler, 400));
  }

  openStep2Form = () => {
    if (this.props.globalData.are_you_a_seller) {
      this.switchFormTwoView(formView.STEP_TWO_SELLER);
      return;
    }
    if (this.props.globalData.type_of_property === propertyType.HOME) {
      this.switchFormTwoView(formView.STEP_TWO_HOME);
    } else {
      this.switchFormTwoView(formView.STEP_TWO_HOTEL);
    }
  };

  backForm = () => {
    if (this.state.formViewMode == formView.STEP_ONE) {
      console.log("can't go back without NavLink");
    } else if (this.state.formViewMode == formView.STEP_THREE) {
      this.openStep2Form();
    } else {
      this.switchFormTwoView(formView.STEP_ONE);
    }
  };

  validate = (target, type) => {
    let isValid;
    const lengthAndSpecialCharRegex = /^[a-zA-Z0-9 ]{1,100}$/;
    const emailRegex = /^$|^(([^<>()\[\]\\.,;:\s@\"]+(\.[^<>()\[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    switch (type) {
      case validation.PHONE_NUMBER:
        if (
          !isNaN(target) &&
          validateUserPhoneNumber(target, this.props.globalData.locale)
        ) {
          this.setState({ stepOneBorderPhoneNumber: true });
          return true;
        }
        return false;
      case validation.HOTEL_EMAIL:
        if (target.length == 0 || !emailRegex.test(target)) return false;
        let aInd = target.indexOf('@');
        if (aInd < 0) return false;
        let dotInd = target.lastIndexOf('.');
        if (dotInd < aInd) return false;
        this.setState({ hotelBorderEmail: true });
        return true;
      case validation.LOCATION:
        if (Object.keys(target).length > 0) {
          this.setState({ stepOneBorderLocation: true });
          return true;
        } else {
          return false;
        }
        return true;
      case validation.ROOM_COUNT:
        return true;
      case validation.FULL_NAME:
        isValid = false;
        if(!lengthAndSpecialCharRegex.test(target)) return false;
        if (target.length > 0) isValid = true;
        if (!this.state.stepOneBorderNameValidated && isValid) {
          this.setState({ stepOneBorderNameValidated: borders.NORMAL_BORDER });
        }
        return isValid;
      case validation.HOTEL_PROPERTY_NAME:
        if (target.length == 0 || !lengthAndSpecialCharRegex.test(target)) return false;
        this.setState({ hotelBorderPropertyValidated: true });
        return true;
      case validation.HOME_ADDRESS:
        if (target.length == 0 || !lengthAndSpecialCharRegex.test(target)) return false;
        this.setState({ homeBorderAddress: true });
        return true;
      case validation.HOME_STRUCTURE_TYPE:
        if (target.length == 0) return false;
        this.setState({ homeBorderStructureType: true });
        return true;
      case validation.SELLER_HOTEL_NAME:
        if (target.length == 0) return false;
        this.setState({ sellerBorderHotelValidated: true });
        return true;
      case validation.SELLER_HOTEL_ADDRESS:
        if (target.length == 0 || !lengthAndSpecialCharRegex.test(target)) return false;
        this.setState({ sellerBorderAddress: true });
        return true;
      case validation.SELLER_NUMBER_OF_ROOMS:
        if (target.length == 0) return false;
        this.setState({ sellerBorderNumberOfRooms: true });
        return true;
      default:
        console.log('validating unknown entity');
        return false;
    }
  };

  validateCurrentForm = () => {
    let { utm_source, utm_medium, utm_campaign } = this.props.globalData;
    let utm_data = getConcatanatedUTMData([
      utm_source,
      utm_medium,
      utm_campaign
    ]);

    let typeOfProperty = 'Hotel';
    if (this.props.globalData.type_of_property === propertyType.HOME) {
      typeOfProperty = 'Home';
    }
    switch (this.state.formViewMode) {
      case formView.STEP_ONE:
        let validateMobileNumber = this.validate(
          this.props.globalData.formData.mobile_number,
          validation.PHONE_NUMBER
        );
        if (!validateMobileNumber)
          this.setState({ stepOneBorderPhoneNumber: false });
        let validateLocation = this.validate(
          this.props.globalData.selected_location,
          validation.LOCATION
        );
        if (!validateLocation) this.setState({ stepOneBorderLocation: false });
        let validateName = this.validate(
          this.props.globalData.formData.full_name,
          validation.FULL_NAME
        );
        if (!validateName) this.setState({ stepOneBorderNameValidated: false });
        let validated =
          validateMobileNumber && validateLocation && validateName;
        if (validated) {
          let toSend = {
            ...this.props.globalData.propertyData.data,
            source: 'OAM',
            sub_source_code: utm_data, //check
            owner_name: this.props.globalData.formData.full_name,
            property_component_type: typeOfProperty,
            street_address: this.props.globalData.formData.hotel_address,
            owner_primary_mobile_number: this.props.globalData.formData
              .mobile_number,
            metadata: {
              freetext: this.state.location,
              medium: 'OAM WEB',
              landingCountry:
                countryNamesByISO[this.props.globalData.locale] ||
                this.props.globalData.locale
            }
          };
          if (this.state.selectedLocation) {
            let selected = this.state.selectedLocation;
            if (selected.city) toSend['city'] = selected.city.name;
            if (selected.country) toSend['country'] = selected.country.name;
          }
          this.props.globalActions.putPropertyfetch(toSend);

          if (this.props.globalData.are_you_a_seller) {
            this.setState({ formViewMode: formView.STEP_TWO_SELLER });
          } else {
            if (this.props.globalData.type_of_property === propertyType.HOME) {
              this.setState({ formViewMode: formView.STEP_TWO_HOME });
            } else {
              this.setState({ formViewMode: formView.STEP_TWO_HOTEL });
            }
          }
          Event(
            'Partner Page Step 1 form',
            'Next button clicked on Step 1 form page',
            'Success',
            ''
          );
        } else {
          Event(
            'Partner Page Step 1 form',
            'Next button clicked on Step 1 form page',
            'Failure',
            ''
          );
        }
        return true;
      case formView.STEP_TWO_HOTEL:
        let validateNameHotel = this.validate(
          this.props.globalData.formData.hotel_name,
          validation.HOTEL_PROPERTY_NAME
        );
        if (!validateNameHotel)
          this.setState({ hotelBorderPropertyValidated: false });

        let validateEmail = this.validate(
          this.props.globalData.formData.email_address,
          validation.HOTEL_EMAIL
        );
        if (!validateEmail) this.setState({ hotelBorderEmail: false });

        if (validateNameHotel && validateEmail) {
          let toSend = {
            ...this.props.globalData.propertyData.data,
            sub_source_code: utm_data,
            street_address: this.props.globalData.formData.hotel_address,
            hotel_total_rooms: this.props.globalData.number_of_rooms,
            property_component_type: typeOfProperty,
            name: this.props.globalData.formData.hotel_name,
            owner_email: this.props.globalData.formData.email_address,
            metadata: {
              operational_currently: this.props.globalData.formData
                .operational_currently
            }
          };
          Event(
            'Partner Page Step 2 form - Hotel',
            'Finish button clicked on Step 2 hotel form page',
            'Success',
            ''
          );

          this.props.globalActions.putPropertyfetch(toSend);
          this.props.globalActions.emptyFormData();
          this.setState({ formViewMode: formView.STEP_THREE });
        } else {
          Event(
            'Partner Page Step 2 form - Hotel',
            'Finish button clicked on Step 2 hotel form page',
            'Failure',
            ''
          );
        }

        return true;
      case formView.STEP_TWO_HOME:
        let validateAddressHome = this.validate(
          this.props.globalData.formData.hotel_address,
          validation.HOME_ADDRESS
        );
        if (!validateAddressHome) {
          this.setState({ homeBorderAddress: false });
        }

        let validateStructType = this.validate(
          this.props.globalData.formData.structure_type_home,
          validation.HOME_STRUCTURE_TYPE
        );
        if (!validateStructType) {
          this.setState({ homeBorderStructureType: false });
        }
        if (!validateAddressHome || !validateStructType)
          Event(
            'Partner Page Step 2 form - Home',
            'Finish button clicked on Step 2 home form page',
            'failure',
            ''
          );

        if (validateStructType && validateAddressHome) {
          Event(
            'Partner Page Step 2 form - Home',
            'Finish button clicked on Step 2 home form page',
            'Success',
            ''
          );

          let toSend = {
            ...this.props.globalData.propertyData.data,
            sub_source_code: utm_data,
            street_address: this.props.globalData.formData.hotel_address,
            property_component_type: typeOfProperty,
            home__structure_type: this.props.globalData.formData
              .structure_type_home,
            ownership: this.props.globalData.formData.are_you_a_owner,
            home__occupancy_status: this.props.globalData.formData
              .occupancy_status
          };

          this.props.globalActions.putPropertyfetch(toSend);
          this.props.globalActions.emptyFormData();
          this.setState({ formViewMode: formView.STEP_THREE });
        }
        return true;
      case formView.STEP_TWO_SELLER:
        let validateNameSeller = this.validate(
          this.props.globalData.formData.hotel_name,
          validation.SELLER_HOTEL_NAME
        );
        if (!validateNameSeller)
          this.setState({ sellerBorderHotelValidated: false });

        let validateAddressSeller = this.validate(
          this.props.globalData.formData.hotel_address,
          validation.SELLER_HOTEL_ADDRESS
        );
        if (!validateAddressSeller)
          this.setState({ sellerBorderAddress: false });

        let validateRooms = this.validate(
          this.props.globalData.number_of_rooms,
          validation.SELLER_NUMBER_OF_ROOMS
        );
        if (!validateRooms) this.setState({ sellerBorderNumberOfRooms: false });

        if (validateNameSeller && validateAddressSeller && validateRooms) {
          let toSend = {
            ...this.props.globalData.propertyData.data,
            sub_source_code: utm_data,
            street_address: this.props.globalData.formData.hotel_address,
            hotel_total_rooms: this.props.globalData.number_of_rooms,
            name: this.props.globalData.formData.hotel_name,
            metadata: {
              property_revenue: this.props.globalData.formData.revenue,
              property_profit: this.props.globalData.formData.profit
            }
          };
          Event('seller form', 'next button clicked', 'success', '');
          this.props.globalActions.putPropertyfetch(toSend);
          this.props.globalActions.emptyFormData();
          this.setState({ formViewMode: formView.STEP_THREE });
        }
        if (!validateNameSeller || !validateAddressSeller || !validateRooms) {
          Event('seller form', 'next button clicked', 'failure', '');
        }

        return true;
      default:
        console.log('validation unknown form');
        return false;
    }
  };
  formResizeHandler = () => {
    if (window.innerWidth < 1025) {
      this.setState({ screenheight: window.innerHeight });
      this.props.globalActions.setHeadingHeightForMobile(true);
      this.setState({ viewSize: 'Mobile', viewMode: view.MOBILE });
    } else {
      this.setState({ screenheight: window.innerHeight });
      this.props.globalActions.setHeadingHeightForMobile(false);
      this.setState({ viewSize: 'Desktop', viewMode: view.DESKTOP });
    }
    if (this.props.globalData.are_you_a_seller) {
      this.props.globalData.type_of_property = propertyType.HOTEL;
    }
  };

  getContent = key => {
    if (
      this.props &&
      this.props.globalData &&
      this.props.globalData.form_translations &&
      this.state.viewMode
    ) {
      return this.props.globalData.form_translations[key];
    }
    return '';
  };

  getUniversalContent = key => {
    if (
      this.props &&
      this.props.globalData &&
      this.props.globalData.universal_translations &&
      this.state.viewMode
    ) {
      if (key in this.props.globalData.universal_translations)
        return this.props.globalData.universal_translations[key];
    }
    return null;
  };

  getStyle = style_id => {
    if (style_id in FormStyles)
      return FormStyles[style_id][this.state.viewMode];
    console.log(style_id + ' style not initialized.');
    return {};
  };

  backToStepOne = () => {
    this.setState({ formViewMode: formView.STEP_ONE });
  };

  switchFormTwoView = formViewMode => {
    this.setState({ formViewMode: formViewMode });
  };

  getImage = image_id => {
    if (image_id in LandingImages)
      return (
        S3HOST +
        '/' +
        this.props.globalData.universal_translations[
          LandingImages[image_id][this.state.viewMode]
        ]
      );
    console.log(image_id + ' image not initialized.');
    return null;
  };

  render() {
    let gc = this.getContent;
    let guc = this.getUniversalContent;
    let gs = this.getStyle;
    let gi = this.getImage;

    let step_one_parent_style = gs('step_one_parent');
    if (this.state.viewMode == view.DESKTOP) {
      step_one_parent_style = {
        ...step_one_parent_style,
        height: this.state.screenheight
      };
    }

    return (
      <React.Fragment>
        {this.props.globalData.form_translations && this.state.viewMode && (
          <div>
            {this.state.viewMode == view.MOBILE && (
              <Header
                formViewMode={this.state.formViewMode}
                showBackButton={true}
                data={1}
                viewMode={this.state.viewMode}
                viewSize={this.props.viewSize}
                headHeight={56}
                centerHead={true}
                backForm={this.backForm}
                guc={guc}
              />
            )}
            <div style={step_one_parent_style}>
              <div style={gs('step_one_child_1')}>
                {this.state.formViewMode == formView.STEP_ONE && (
                  <FormOne
                    viewMode={this.state.viewMode}
                    getImage={this.getImage}
                    getStyle={this.getStyle}
                    getContent={this.getContent}
                    getUniversalContent={this.getUniversalContent}
                    validateCurrentForm={this.validateCurrentForm}
                    stepOneBorderNameValidated={
                      this.state.stepOneBorderNameValidated
                    }
                    stepOneBorderPhoneNumber={
                      this.state.stepOneBorderPhoneNumber
                    }
                    stepOneBorderLocation={this.state.stepOneBorderLocation}
                    validate={this.validate}
                    screenheight={this.state.screenheight}
                    updateLocationtext={query =>
                      this.setState({ location: query })
                    }
                  />
                )}

                {this.state.formViewMode == formView.STEP_TWO_SELLER && (
                  <FormSeller2
                    viewMode={this.state.viewMode}
                    getImage={this.getImage}
                    getStyle={this.getStyle}
                    getContent={this.getContent}
                    getUniversalContent={this.getUniversalContent}
                    validateCurrentForm={this.validateCurrentForm}
                    backToStepOne={this.backToStepOne}
                    switchFormTwoView={this.switchFormTwoView}
                    sellerBorderHotelValidated={
                      this.state.sellerBorderHotelValidated
                    }
                    sellerBorderAddress={this.state.sellerBorderAddress}
                    sellerBorderNumberOfRooms={
                      this.state.sellerBorderNumberOfRooms
                    }
                    validate={this.validate}
                    screenheight={this.state.screenheight}
                  />
                )}
                {this.state.formViewMode == formView.STEP_TWO_HOTEL && (
                  <FormHotel2
                    viewMode={this.state.viewMode}
                    getImage={this.getImage}
                    getStyle={this.getStyle}
                    getContent={this.getContent}
                    getUniversalContent={this.getUniversalContent}
                    backToStepOne={this.backToStepOne}
                    validateCurrentForm={this.validateCurrentForm}
                    switchFormTwoView={this.switchFormTwoView}
                    hotelBorderPropertyValidated={
                      this.state.hotelBorderPropertyValidated
                    }
                    hotelBorderEmail={this.state.hotelBorderEmail}
                    validate={this.validate}
                    screenheight={this.state.screenheight}
                  />
                )}

                {this.state.formViewMode == formView.STEP_TWO_HOME && (
                  <FormHome2
                    viewMode={this.state.viewMode}
                    getImage={this.getImage}
                    getStyle={this.getStyle}
                    getContent={this.getContent}
                    getUniversalContent={this.getUniversalContent}
                    backToStepOne={this.backToStepOne}
                    validateCurrentForm={this.validateCurrentForm}
                    switchFormTwoView={this.switchFormTwoView}
                    homeBorderStructureType={this.state.homeBorderStructureType}
                    homeBorderAddress={this.state.homeBorderAddress}
                    validate={this.validate}
                    screenheight={this.state.screenheight}
                  />
                )}

                {this.state.formViewMode == formView.STEP_THREE && (
                  <Form3New
                    viewMode={this.state.viewMode}
                    getImage={this.getImage}
                    getStyle={this.getStyle}
                    getContent={this.getContent}
                    getUniversalContent={this.getUniversalContent}
                    screenheight={this.state.screenheight}
                  />
                )}
              </div>

              {this.state.viewMode == view.DESKTOP && (
                <div style={gs('step_one_child_2')}>
                  <StaticContent
                    getImage={this.getImage}
                    getStyle={this.getStyle}
                    getContent={this.getContent}
                    formViewMode={this.state.formViewMode}
                    globalData={this.props.globalData}
                    screenheight={this.state.screenheight}
                  />
                </div>
              )}
            </div>
          </div>
        )}
      </React.Fragment>
    );
  }
}

const mapDispatchToProps = dispatch => {
  return {
    globalActions: bindActionCreators(GlobalActions, dispatch),
    translationActions: bindActionCreators(TranslationActions, dispatch)
  };
};

const mapStateToProps = state => {
  return {
    globalData: state.globalReducer
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(FormScreenNew);
